/* eslint-disable no-shadow */
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export enum MsgType {
  Individual,
  GroupText,
}

@Component({
  selector: 'app-no-contact-dialog',
  templateUrl: './no-contact-dialog.component.html',
  standalone: false,
  styleUrl: './no-contact-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoContactDialogComponent {
  MsgType = MsgType;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: MsgType,
  ) {}
}
